import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * App-level user preferences, cached locally so they survive reloads and load
 * instantly (no flash / no refetch). Persisted to localStorage under
 * `ggdesk-settings`. Theme is handled separately in ThemeContext.
 */
interface SettingsState {
  notifications: boolean;
  autoUpdate: boolean;
  setNotifications: (value: boolean) => void;
  setAutoUpdate: (value: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      notifications: true,
      autoUpdate: true,
      setNotifications: (value) => set({ notifications: value }),
      setAutoUpdate: (value) => set({ autoUpdate: value }),
    }),
    {
      name: 'ggdesk-settings',
      version: 1,
    }
  )
);
